import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { SIDEBAR_DEFAULT_WIDTH, SIDEBAR_MAX_WIDTH, SIDEBAR_MIN_WIDTH, } from '#pplx/frontend/sidebar-sdk/sidebarResizeConstants.js';
import { useCallback, useMemo, useSyncExternalStore } from 'react';
export function clampSidebarWidth(width) {
    if (!Number.isFinite(width))
        return SIDEBAR_DEFAULT_WIDTH;
    return Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, Math.round(width)));
}
const previewStores = new Map();
function getPreviewStore(settingName) {
    const existing = previewStores.get(settingName);
    if (existing)
        return existing;
    const listeners = new Set();
    let preview = null;
    const store = {
        previewWidth: (width) => {
            preview = width === null ? null : clampSidebarWidth(width);
            listeners.forEach((listener) => listener());
        },
        subscribe: (listener) => {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
                if (listeners.size === 0)
                    preview = null;
            };
        },
        getPreview: () => preview,
    };
    previewStores.set(settingName, store);
    return store;
}
const getServerPreview = () => null;
export function useSidebarWidth(settingName = 'sidebarWidth') {
    const [storedWidth, setStoredWidth, readStoredWidth] = useLocalUserSettings(settingName, SIDEBAR_DEFAULT_WIDTH);
    const { previewWidth, subscribe, getPreview } = getPreviewStore(settingName);
    const liveWidth = useSyncExternalStore(subscribe, getPreview, getServerPreview);
    // Read at handoff so other consumers don't revert while their storage updates await RAF.
    const savedWidth = useMemo(() => (liveWidth === null ? readStoredWidth() : storedWidth), [liveWidth, storedWidth, readStoredWidth]);
    const setWidth = useCallback((width) => {
        setStoredWidth(clampSidebarWidth(width));
        previewWidth(null);
    }, [setStoredWidth, previewWidth]);
    return { width: liveWidth ?? clampSidebarWidth(savedWidth), setWidth, previewWidth };
}
//# sourceMappingURL=useSidebarWidth.js.map